import { ElementType } from 'react';
import clsx from 'clsx';
import styles from './FeatureHighlight.module.css';

type TProps = {
  icon: ElementType;
  feature: string;
  description?: string;
  className?: string;
};

export const FeatureHighlight = ({
  icon: Icon,
  feature,
  description,
  className,
}: TProps) => {
  return (
    <div className={clsx(styles.featureHighlight, className)}>
      <div className={styles.iconWrapper}>
        <Icon fontSize="20px" />
      </div>
      <span>
        <span className={styles.feature}>{feature}</span>
        {description && (
          <span className={styles.description}> ({description})</span>
        )}
      </span>
    </div>
  );
};
